<template>
  <div
    class="h-toast"
    v-if="true"
    :class="{ 'fade-in': fadeIn, 'fade-out': fadeOut }"
  >
    {{ message }}
  </div>
</template>

<script>
// 自定义消失时间（5秒）
// this.$htoast({
//   message: "请输入用户名",
//   duration: 5000
// })
export default {
  data() {
    return {
      message: '',
      visible: false,
      fadeIn: false,
      fadeOut: false,
      duration: 3000, // 默认3秒后消失
      timer: null, // 用于清除定时器
    }
  },
  methods: {
    // 显示toast
    show(msg, time) {
      // 清除之前的定时器
      if (this.timer) {
        clearTimeout(this.timer)
      }

      this.message = msg
      this.duration = time || 3000

      // 显示toast并触发动画
      this.visible = true
      this.fadeIn = true
      this.fadeOut = false

      // 定时隐藏
      this.timer = setTimeout(() => {
        this.fadeOut = true
        this.fadeIn = false

        // 等待淡出动画完成后隐藏
        setTimeout(() => {
          this.visible = false
          this.message = ''
          this.timer = null
        }, 300)
      }, this.duration)
    },
  },
}
</script>

<style lang="scss" scoped>
.h-toast {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.8);
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  line-height: 20px;
  padding: 13px 24px;
  border-radius: 12px;
  z-index: 9999;
  opacity: 0;
  transition: all 0.3s ease;
  pointer-events: none; // 防止点击穿透
  max-width: 188px; // 限制最大宽度
  text-align: left;
}

// 淡入动画
.fade-in {
  opacity: 1;
  transform: translateX(-50%);
}

// 淡出动画
.fade-out {
  opacity: 0;
  transform: translateX(-50%) translateY(-10px);
}
</style>
